var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaunch1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32.381,
    height: 32.381,
    rx: 16.1905,
    fill: "#D7F9FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3992 13.9414H22.5574C24.1003 13.9414 24.5589 14.1627 24.5217 15.2612C24.4602 17.0809 23.6396 19.1953 20.3571 19.7747",
    stroke: "#007E8C",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1457 22.111C8.33369 19.949 7.91938 16.8824 7.85834 13.6824C7.83197 12.3 8.2332 12.0156 10.0731 12.0156H18.9745C20.8144 12.0156 21.2156 12.3 21.1893 13.6824C21.1282 16.8824 20.7139 19.949 17.9019 22.111C17.1016 22.7263 16.4264 22.849 15.29 22.849H13.7577C12.6212 22.849 11.946 22.7263 11.1457 22.111Z",
    stroke: "#007E8C",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunch1);
export default __webpack_public_path__ + "static/media/launch-1.7db97f35a702feffc7bd3ef2277addf3.svg";
export { ForwardRef as ReactComponent };